import { createReducer } from '@reduxjs/toolkit';
import {
  records as appStorageRecords,
  actions as appStorageActions,
} from '@saucelabs/sl-module-app-storage';

interface UploadState {
  readonly items: (appStorageRecords.AppStorageFileUpload | undefined)[]
}

const initialState: UploadState = {
  items: [],
};

const uploadReducer = createReducer(initialState, (builder) => {
  builder.addCase(appStorageActions.uploadFilePending, (draft, { payload }) => {
    const currentUploadIndex = draft.items.findIndex(
      (item) => item?.id === payload.currentUpload.id,
    );
    if (currentUploadIndex !== -1) {
      draft.items[currentUploadIndex] = payload.currentUpload;
    } else {
      draft.items.push(payload.currentUpload);
    }
  });

  builder.addCase(appStorageActions.uploadFileProgress, (draft, { payload }) => {
    const currentUploadIndex = draft.items.findIndex(
      (item) => item?.id === payload.currentUpload.id,
    );
    if (currentUploadIndex !== -1) {
      draft.items[currentUploadIndex] = payload.currentUpload;
    }
  });

  builder.addCase(appStorageActions.uploadFileFulfilled, (draft, { payload }) => {
    const currentUploadIndex = draft.items.findIndex(
      (item) => item?.id === payload.currentUpload.id,
    );
    if (currentUploadIndex !== -1) {
      draft.items.splice(currentUploadIndex, 1);
    }
  });

  builder.addCase(appStorageActions.uploadFileRejected, (draft, { payload }) => {
    const currentUploadIndex = draft.items.findIndex(
      (item) => item?.id === payload.currentUpload.id,
    );
    if (currentUploadIndex !== -1) {
      draft.items.splice(currentUploadIndex, 1);
    }
  });
});

export default uploadReducer;
export {
  initialState,
  UploadState,
};
